import germanTranslations from '../translations/de.json';
import englishTranslations from '../translations/en.json';
import frenchTranslations from '../translations/fr.json';
import italianTranslations from '../translations/it.json';
import germanPrivacyPolicyTranslations from '../translations/PrivacyPolicy/de.json';
import englishPrivacyPolicyTranslations from '../translations/PrivacyPolicy/en.json';
import frenchPrivacyPolicyTranslations from '../translations/PrivacyPolicy/fr.json';
import italianPrivacyPolicyTranslations from '../translations/PrivacyPolicy/it.json';
import germanBenchmarkingTranslations from '../translations/Benchmarking/de.json';
import englishBenchmarkingTranslations from '../translations/Benchmarking/en.json';
import frenchBenchmarkingTranslations from '../translations/Benchmarking/fr.json';
import italianBenchmarkingTranslations from '../translations/Benchmarking/it.json';
import merger from "./common/Merger";

const privacyPlusBenchmarkingDE = merger.merge(germanPrivacyPolicyTranslations, germanBenchmarkingTranslations);
const privacyPlusBenchmarkingEN = merger.merge(englishPrivacyPolicyTranslations, englishBenchmarkingTranslations);
const privacyPlusBenchmarkingFR = merger.merge(frenchPrivacyPolicyTranslations, frenchBenchmarkingTranslations);
const privacyPlusBenchmarkingIT = merger.merge(italianPrivacyPolicyTranslations, italianBenchmarkingTranslations);


export function createConfig(initialLanguageKey) {
    const resources = {
        de: { translation: merger.merge(germanTranslations, privacyPlusBenchmarkingDE) },
        en: { translation: merger.merge(englishTranslations, privacyPlusBenchmarkingEN) },
        fr: { translation: merger.merge(frenchTranslations, privacyPlusBenchmarkingFR) },
        it: { translation: merger.merge(italianTranslations, privacyPlusBenchmarkingIT) },
    };
    return {
        resources,
        lng: initialLanguageKey,
        fallbackLng: 'de',
        keySeparator: true, // easier to find usages in code
    }
}